import { Order } from '@mc/api'
import { getCertsLines } from './certsLines'

/**
 * Whether a completed order includes the certificate credit add-on.
 *
 * Read off the order rather than the cart because the cart is destroyed
 * server-side once the order processes (`new_order_processor` / the 3DS confirm
 * path), and the post-purchase certs page refetches `['cartProducts']` itself.
 * The order carries the pre-purchase line items, so it is the only sound
 * post-purchase signal for what was actually bought.
 *
 * Kept out of the module barrel: the state machine imports this, and the barrel
 * pulls in React components and a registered i18n namespace.
 */
export const hasCertCreditAddOnPurchase = (order?: Order) =>
  !!getCertsLines(order?.products).certificate
